export const ACCENT = "#FE0000";

export const HOST = {
  name: "Reginald R. Cole",
  fullName: "Reginald R. Cole",
  company: "US Lending Partner PRMG",
  nmls: "381001",
  companyNmls: "75243",
  states: "Texas",
  initials: "RC",
};

export const CONTACT = {
  phone: "(972) 439-5363",
  phoneTel: "+19724395363",
  email: "reginald@reginaldcole.com",
};

export const ASSETS = {
  regLogo: "/images/reg-logo.png",
  headshot: "/images/headshot.png",
  usl1: "/images/usl1.jpg",
  usl2: "/images/usl2.jpg",
  eagle: "/images/eagle.jpg",
};

export const luxStyle = (n) => ({
  backgroundImage: `linear-gradient(rgba(20,40,72,0.92), rgba(20,40,72,0.95)), url(/images/lux${n}.jpg)`,
  backgroundSize: "cover",
  backgroundPosition: "center",
});

export const WEBINAR = {
  title: "REG VA ADVANTAGE",
  topic: "VA HOME LOANS",
  duration: "45 MINUTES",
  modules: 5,
  geo: "TEXAS",
  dateLine: "LIVE — SEPTEMBER 29, 2026 · 7:00 PM CDT",
};

export const WEBINAR_DATE = "2026-09-29T19:00:00-05:00";

export const EYEBROW = "FREE 45-MIN LIVE BRIEFING — TEXAS VETERANS & ACTIVE DUTY";

export const BONUSES = [
  "Free Live Webinar Access",
  "VA Loan Eligibility Breakdown",
  "Get Ready Credit Coaching Program",
  "Builder Incentive Negotiation Coaching",
  "Optional 1-on-1 Call with Reginald",
];

export const FALSE_BELIEFS = [
  '"I can\'t get approved."',
  '"VA loans are great, but the approval process is complicated and slow."',
  '"I need a lender AND a realtor, and they\'ll never be on the same page."',
];

export const REVELATIONS = [
  "\u201cI can't get approved\u201d is a snapshot, not a life sentence. Most lenders never ran the VA math.",
  "The process only feels complicated in fragments. One person owning the whole map turns it into simple steps.",
  "When financing and representation sit on YOUR side of the table, builder incentive desks lose their edge.",
];

export const AUDIENCE_CARDS = [
  { emoji: "🎖️", text: "Veterans Exploring Homeownership Options" },
  { emoji: "🪖", text: "Active Duty Service Members Preparing to Buy" },
  { emoji: "🏠", text: "Guard & Reserve Members Who Qualify for VA Benefits" },
  { emoji: "💍", text: "Surviving Spouses with VA Loan Eligibility" },
  { emoji: "❓", text: 'Anyone Who\'s Been Told "I Can\'t Get Approved"' },
];

export const ROADMAP = [
  { num: "01", label: "STEP ONE", name: "RESERVE", desc: "Claim your free seat. Takes 60 seconds — no credit pull, no obligation." },
  { num: "02", label: "STEP TWO", name: "WATCH", desc: "Join the live 45-minute briefing. Five modules, plain language, live Q&A." },
  { num: "03", label: "STEP THREE", name: "PREPARE", desc: "Use the Get Ready checklist to line up documents and credit steps." },
  { num: "04", label: "STEP FOUR", name: "DECIDE", desc: "Take the optional 1-on-1 strategy call — or simply walk away better informed." },
];

export const MODULES = [
  { num: "01", title: "UNDERSTAND THE PATH", body: "The VA loan process from pre-approval to closing — step by step." },
  { num: "02", title: "KNOW WHAT TO PREPARE", body: "The exact documents and credit steps to line up first." },
  { num: "03", title: "EXPLORE VA LOAN CONSIDERATIONS", body: "Entitlement, funding fee, zero-down and no-PMI — explained simply." },
  { num: "04", title: "AVOID COMMON MISSTEPS", body: "How builder incentive desks out-negotiate unrepresented buyers." },
  { num: "05", title: "LEAVE WITH NEXT STEPS", body: "A clear checklist + optional call. No credit pull, no commitment." },
];

export const TRANSFORMS = [
  "Know exactly which documents to gather first",
  "Know which eligibility factors actually matter",
  "Get a clear next step — no credit pull, no commitment",
];

export const PAIN_PARAGRAPHS = [
  "You called a lender. You heard \u201cnot yet.\u201d Nobody explained what has to change.",
  "The problem isn't the \u201cno\u201d — it's the fog. This briefing clears it.",
];

export const BIO_PARAGRAPHS = [
  "I've spent my career inside the mortgage process — underwriting calls, builder negotiations, closing tables — helping Texas veterans use the benefit they earned.",
  "VA loans aren't hard. They just need someone to show you the whole path. This 45-minute briefing is that sit-down: plain language, no application, no credit pull.",
];

export const MANIFESTO_PARAGRAPH =
  "One free 45-minute briefing. The entire VA loan path in plain language — your entitlement, what to prepare, and where buyers get out-negotiated.";

export const TAKEAWAYS = [
  { emoji: "🗺️", title: "CLEARER VIEW", desc: "A plain-language map of the VA loan process from eligibility to keys." },
  { emoji: "✅", title: "PREPARATION CHECKLIST", desc: "The Get Ready Program steps — documents, credit moves, timing." },
  { emoji: "💬", title: "QUESTIONS TO ASK", desc: "What to ask any lender, agent, or builder before you sign anything." },
  { emoji: "📋", title: "OPTIONAL NEXT STEP", desc: "One application, one call — no credit pull, no obligation." },
];

export const FAQS = [
  { q: "Is the webinar free?", a: "Yes — 100% free. Nothing is sold during the training." },
  { q: "Is this a loan application?", a: "No. It's education only. Any application afterward is optional and separate." },
  { q: "Will attending affect my credit?", a: "No. No credit pull of any kind — hard or soft." },
  { q: "Who is this webinar for?", a: "Texas veterans, active duty, Guard/Reserve, and surviving spouses — especially anyone told \u201cyou can't get approved.\u201d" },
  { q: "What will be covered?", a: "The VA loan path, what to prepare, entitlement & zero-down basics, builder negotiation pitfalls, and your next steps." },
  { q: "Is it live or on demand?", a: "Live with Q&A — September 29, 2026 at 7:00 PM CDT. Register to lock in your seat." },
  { q: "What happens after I register?", a: "You get a confirmation with access details. No calls unless you request one." },
  { q: "Do I have to speak with a loan officer?", a: "No. The 1-on-1 call is optional — never required." },
];

export const TICKER_ITEMS = [
  "45 MINUTES",
  "5 CORE MODULES",
  "LIVE Q&A INCLUDED",
  "TEXAS COVERAGE",
  "NO COST TO ATTEND",
  "VA HOME LOAN SPECIALISTS",
];

export const CONSENT_TEXT =
  "I agree to receive communications about this webinar and related educational content from Reginald R. Cole / US Lending Partner PRMG. Message and data rates may apply. Consent is not a condition of any purchase. Reply STOP to opt out at any time.";

export const COMPLIANCE_DISCLOSURE =
  "This is an educational webinar. Attendance does not constitute a loan application. No credit pull required. Results are not guaranteed. Equal Housing Opportunity. Reginald R. Cole NMLS# 381001, US Lending Partner PRMG NMLS# 75243.";

export const COPYRIGHT_LINE = "© 2026 US Lending Partner · WAM.WEBINAR v2.0";

export const STATE_OPTIONS = [
  "Texas", "Alabama", "Arizona", "Arkansas", "California", "Colorado", "Florida", "Georgia",
  "Louisiana", "Mississippi", "Missouri", "New Mexico", "North Carolina", "Oklahoma",
  "Tennessee", "Virginia", "Other",
];

export const QUALIFIERS = [
  {
    key: "vaBenefitUsage",
    label: "Have you used your VA home loan benefit before?*",
    options: ["Never used it", "Used it once", "Not sure"],
  },
  {
    key: "householdIncome",
    label: "What's your approximate household income?*",
    options: ["Under $65K", "$65K+", "Not sure"],
  },
  {
    key: "buyTimeline",
    label: "When are you looking to buy in Texas?*",
    options: ["0-3 months", "3-6 months", "6-12 months", "Just researching"],
  },
];

export const JOURNEY_OPTIONS = [
  "Just exploring my VA benefit",
  "Buying in the next 0–3 months",
  "Buying in 3–6 months",
  "Buying in 6–12 months",
  "I've been told I can't get approved",
];
